/*
 * @providesModule BankWithdrawalHooks
 */

export const QUERY_KEYS = {
  paymentData: 'paymentData',
};

export * from './usePaymentDataQuery';
